import { Link } from "react-router-dom";
import { site } from "../../../mocks/site";

export default function AboutBand() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-16 md:py-20">
      <div className="grid grid-cols-1 items-center gap-10 rounded-3xl border border-background-200/70 bg-background-50 p-8 md:p-12 lg:grid-cols-2">
        <div>
          <p className="text-sm text-primary-600 font-medium">关于甜心剧情站</p>
          <h2 className="mt-2 font-display text-3xl text-foreground-950 md:text-4xl">
            和你一样，认真对待每一个故事
          </h2>
          <p className="mt-4 text-sm leading-7 text-foreground-700">
            {site.name} 是一群守护甜心老观众自发整理的内容站。我们相信：好的剧情经得起反复回味，
            也需要被认真梳理。分集速览、设定解析、结局详解——所有内容都以“讲清楚、讲准确、讲得暖”为目标。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm text-background-50 whitespace-nowrap hover:bg-primary-600"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
            <Link
              to="/analysis"
              className="inline-flex items-center gap-2 rounded-full bg-background-100 px-6 py-3 text-sm text-foreground-800 whitespace-nowrap hover:bg-secondary-100"
            >
              看全部解析
            </Link>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[
            { num: "3", label: "部动画正片", icon: "ri-film-line", tone: "bg-primary-100 text-primary-700" },
            { num: "127", label: "集剧情逐集梳理", icon: "ri-list-check-2", tone: "bg-secondary-100 text-secondary-800" },
            { num: "6+", label: "篇深度剧情解析", icon: "ri-quill-pen-line", tone: "bg-accent-100 text-accent-800" },
            { num: "100%", label: "按序对照剧情进度", icon: "ri-check-double-line", tone: "bg-primary-100 text-primary-700" },
          ].map((s) => (
            <div key={s.label} className="rounded-2xl border border-background-200/70 bg-background-50 p-5">
              <span className={`flex h-10 w-10 items-center justify-center rounded-xl text-xl ${s.tone}`}>
                <i className={s.icon} />
              </span>
              <p className="mt-3 font-display text-2xl text-foreground-950">{s.num}</p>
              <p className="mt-1 text-xs text-foreground-600">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}